import { ClientPathSchema } from "@/features/dashboard/client/clientSchema";
import { IdentificationHistoryDetailPage } from "@/features/dashboard/client/detail/components/identification-edit/pages/IdentificationHistoryDetailPage";
import { IdentificationEditReturnTo } from "@/features/dashboard/client/identification-list/identificationListEnum";
import { IdentificationSearchSchema } from "@/features/dashboard/client/identification-list/identificationListSchema";
import { usePageTitle } from "@/hooks/usePageTitle";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const IdentificationHistoryPathSchema = ClientPathSchema.extend({
  historyId: z.coerce.number().int(),
});

const IdentificationHistorySearchSchema = IdentificationSearchSchema.extend({
  returnTo: z.enum(Object.values(IdentificationEditReturnTo)).optional(),
});

export const Route = createFileRoute(
  "/_dashboard/clients/$clientId/identification/histories/$historyId"
)({
  component: RouteComponent,
  parseParams: IdentificationHistoryPathSchema.parse,
  validateSearch: IdentificationHistorySearchSchema,
});

function RouteComponent() {
  usePageTitle("本人確認履歴詳細");
  return <IdentificationHistoryDetailPage />;
}
